import D2C_Host from '../Host'
import objects from '@/objects'

class D2C_HostCustom extends D2C_Host {
  isCustom = true
  static objectType = 'hostType'
  static groupName = 'custom'
  static groupTitle = 'Custom'
  static providerType = 'custom'
  static providerTitle = 'Custom'
  static color = '#666666'
  static processes = {
    ...D2C_Host.processes,
    AWAITING_CONNECTION: 'AWAITING_CONNECTION',
  }
  static methods = {
    ...D2C_Host.methods,
    connect: true,
  }
  static fields = {
    ...D2C_Host.fields,
    amt: {
      ...D2C_Host.fields.amt,
      readonly: true,
      omit: true,
    },
    provider: {
      ...D2C_Host.fields.provider,
      omit: true,
    },
  }
  get _provider() {
    return objects.Provider.create({type: 'custom'})
  }
  get _instance() {
    return objects.Instance.create({...this.instanceData, providerType: 'custom'})
  }
  get _region() {
    return objects.Region.create({...this.regionData, providerType: 'custom'})
  }
}

export default D2C_HostCustom
